// extracted by mini-css-extract-plugin
export var linkText = "_oq-0";